import { toRadians } from 'platform/utilities/facilities-and-mapbox';
import { LocationType, MIN_RADIUS_EXP, MIN_RADIUS_NCA } from '../constants';

export function distBetween(lat1, lng1, lat2, lng2) {
  const R = 3959; // radius in miles
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lng2 - lng1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) *
      Math.sin(dLon / 2) *
      Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2));
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}

export const radiusFromBoundingBox = (
  fbox,
  facilityType = LocationType.HEALTH,
) => {
  const [west, south, east, north] = fbox[0].bbox;
  const centerLat = (south + north) / 2;
  const centerLng = (west + east) / 2;
  // Use the larger half-span to accommodate the full rectangular map area:
  // portrait (height > width) → nsHalf; landscape (width > height) → ewHalf
  const nsHalf = distBetween(centerLat, centerLng, north, centerLng);
  const ewHalf = distBetween(centerLat, centerLng, centerLat, west);
  const radius = Math.max(nsHalf, ewHalf);

  let radiusToUse = radius;

  if (facilityType === LocationType.CEMETERY) {
    radiusToUse = MIN_RADIUS_NCA;
  } else if (radius < MIN_RADIUS_EXP) {
    radiusToUse = MIN_RADIUS_EXP;
  }

  return [radius, radiusToUse];
};
